import React from 'react'
import { useSelector } from 'react-redux'
import { getCommonState } from '../../../store/common/selector'

function PermissionWrapper(props: any) {
  const commonState = useSelector(getCommonState)
  if (
    commonState &&
    commonState.user &&
    (commonState.user.is_superadmin ||
      commonState.user.role === 'superadmin' ||
      commonState.user.role === 'admin')
  ) {
    return props.children
  }
  return <></>
}

export default PermissionWrapper
